// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.displayname {
  max-height: 45px;
  line-height: 16px;
}

.inTableImage {
  max-width: 30px;
  max-height: 30px;
  background: url("/assets/dashboard/back4.jpeg") no-repeat center center;
}

ion-item, ion-label {
  user-select: none;
  -webkit-user-select: none;
}

ion-label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-box/minibox/minibox.component.scss"],"names":[],"mappings":"AAMA;EACE,gBAAA;EACA,iBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,uEAAA;AALF;;AAUA;EACE,iBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAPF","sourcesContent":["\n.fieldcellItem {\n  //max-height: 31px;\n  //--min-height: 31px;\n}\n\n.displayname {\n  max-height: 45px;\n  line-height: 16px;\n}\n\n.inTableImage {\n  max-width: 30px;\n  max-height: 30px;\n  background: url('/assets/dashboard/back4.jpeg') no-repeat center center;\n  //padding-right: 3px;\n  //width: auto;\n}\n\nion-item, ion-label {\n  user-select: none;\n  -webkit-user-select: none;\n}\n\nion-label {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
